import { render, staticRenderFns } from "./privilegeDialog.vue?vue&type=template&id=4f6da4c5&"
import script from "./privilegeDialog.vue?vue&type=script&lang=js&"
export * from "./privilegeDialog.vue?vue&type=script&lang=js&"
import style0 from "./privilegeDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports